module.exports = __webpack_public_path__ + "static/media/proffesional.6fbce282.png";